import { z } from "zod";
// Claims on the portal-issued SSO user JWT.
// Inspected from /home/qxl/projects/portal/apps/api/src/services/auth/signToken.ts:
//   - subject: portal User.id (CUID, NOT a UUID — kept opaque server-side)
//   - audience: the system slug (e.g. "qlik-scheduler")
//   - issuer: "ashcourt-portal"
//   - body claims: { email, name, role, grants }
//   - jose surfaces sub/aud/iss/exp/jti at the top level after verify
export const PortalJwtClaims = z.object({
    sub: z.string().min(1), // portal User.id — CUID, NOT UUID
    email: z.string().email(),
    name: z.string().min(1),
    role: z.enum(["USER", "ADMIN"]).optional(),
    grants: z.array(z.string()).optional(),
    jti: z.string(),
    iss: z.literal("ashcourt-portal"),
    aud: z.string(), // equality-checked against PORTAL_SYSTEM_SLUG by the verifier
    exp: z.number(),
    iat: z.number().optional(),
});
// What the frontend sees about the current user. userId is the portal-side
// User.id (CUID); not a UUID. Treated as an opaque string everywhere.
export const CurrentUser = z.object({
    userId: z.string().min(1),
    email: z.string().email(),
    name: z.string(),
});
//# sourceMappingURL=auth.js.map